var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReparacionNeumaticoIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reparacion_icono",
    d: "M1685,2096.5a20.5,20.5,0,1,1,20.5,20.5A20.523,20.523,0,0,1,1685,2096.5Zm1.708,0a18.792,18.792,0,1,0,18.792-18.791A18.814,18.814,0,0,0,1686.708,2096.5Zm3.417,0a15.375,15.375,0,1,1,15.375,15.375A15.392,15.392,0,0,1,1690.125,2096.5Zm16.229,10.25a.854.854,0,1,1,0,1.708v1.665a13.667,13.667,0,1,0-1.708,0v-1.665a.854.854,0,1,1,0-1.708Zm15.375-10.25a16.02,16.02,0,0,0-1.739-7.3.855.855,0,0,1,1.526-.771,17.72,17.72,0,0,1,1.922,8.075.854.854,0,0,1-1.708,0Zm-3.907-10.55a16.407,16.407,0,0,0-2.585-2.426.854.854,0,0,1,1.027-1.365,18.087,18.087,0,0,1,2.854,2.679.854.854,0,1,1-1.3,1.112Z",
    transform: "translate(-1685 -2076)",
    fill: "#293338"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReparacionNeumaticoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reparacion_neumatico_icon.b36953cd.svg";
export { ForwardRef as ReactComponent };